SA.Tooltip = class {
    get tpl() {
        return [
            '<div class="sa-tooltip-arrow"></div>',
            '<div class="sa-tooltip-content"></div>'
        ].join('');
    }

    constructor({content, target}) {
        this.onWindowMouseOver = this.onWindowMouseOver.bind(this);

        this.el = document.body.appendChild(this.createEl({content}));
        this.popperInstance = this.createPopper({target});
        this.target = target;
        this.timeout = setTimeout(() => this.el.classList.add('sa-tooltip-visible'), 250);

        addEventListener('mouseover', this.onWindowMouseOver);
    }

    createEl({content}) {
        var el = document.createElement('div');

        el.classList.add('sa-tooltip');
        el.innerHTML = this.tpl;
        el.querySelector('.sa-tooltip-content').innerHTML = content;

        return el;
    }

    createPopper({target}) {
        return Popper.createPopper(target, this.el, {
            placement: 'auto',

            modifiers: [
                {
                    name: 'arrow',

                    options: {
                        element: '.sa-tooltip-arrow',
                        padding: 5
                    }
                }, {
                    name: 'offset',
                    options: {offset: [0, 7]}
                }
            ]
        });
    }

    destroy() {
        removeEventListener('mouseover', this.onWindowMouseOver);

        clearTimeout(this.timeout);

        if (this.el.classList.contains('sa-tooltip-visible')) {
            this.el.classList.remove('sa-tooltip-visible');
            setTimeout(finishDestroy.bind(this), 250);
        }
        else {
            finishDestroy.call(this);
        }

        function finishDestroy() {
            this.popperInstance.destroy();
            this.el.remove();
        }
    }

    onWindowMouseOver(ev) {
        if (!this.target.contains(ev.target)) {
            this.destroy();
        }
    }
};